export default __webpack_public_path__ + "images/gw-header-image-53.png?8d46863ef7b39d90fdb2ae8d0b9f4120";